var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8682 2.50386C10.6902 2.19229 10.3589 2 10 2C9.64114 2 9.3098 2.19229 9.13176 2.50386L1.13176 16.5039C0.954898 16.8134 0.956168 17.1936 1.13509 17.5019C1.31401 17.8102 1.64353 18 2 18H18C18.3565 18 18.686 17.8102 18.8649 17.5019C19.0438 17.1936 19.0451 16.8134 18.8682 16.5039L10.8682 2.50386ZM10 5.01556L16.2768 16H3.72318L10 5.01556ZM10.9999 9.99997C10.9999 9.44769 10.5522 8.99997 9.99988 8.99997C9.44759 8.99997 8.99988 9.44769 8.99988 9.99997V13.3333C8.99988 13.8856 9.44759 14.3333 9.99988 14.3333C10.5522 14.3333 10.9999 13.8856 10.9999 13.3333V9.99997Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.3d7d686d.svg";
export { ForwardRef as ReactComponent };